import Vue from "vue";
import Vuex from "vuex";
import common from "./common";
import team from "./team";

Vue.use(Vuex);
export default new Vuex.Store({
    modules: { common, team }
});
